import React, { useState, useEffect } from "react";
import {
  BackButton,
  FormLabel,
  InputWrapper,
  Question,
  RegistrationWrapper,
  Text,
} from "../NoCarNumber.style";
import "styled-components";
import { Button } from "../../../../../components/Button/Button";
import AutoCompleteSelect from "../../../../../components/AutoCompleteSelect/AutoComplete";
import { useRTOQuery } from "../../../../../services/CarServices";
import getLastNYears from "../../../../../utils/getLastFifteenYears";
import { useDispatch, useSelector } from "react-redux";
import {
  noNumberSelector,
  setRtoDetails,
  setRegistrationYear,
  setIsRegistered,
  setRegistrationDate,
  setPurchaseDate
} from "../../../Landing.slice";
import RadioButton from "../../../../../components/RadioButton/RadioButton";
import DatePicker from "../../../../../components/DatePicker/DatePicker";

const Registration = ({ setActive, active, onSave }) => {
  const { isLoading, rtoList } = useRTOQuery();
  const dispatch = useDispatch();
  const { rto_id, registration_year, rto_name, isRegistered, registration_date, purchase_date } = useSelector(noNumberSelector);

  const [errors, setErrors] = useState({
    registration_year: "",
    rto_name: "",
    isRegistered: "",
    registration_date: "",
    purchase_date: ""
  });
  useEffect(() => {
    if (!isRegistered) {
      dispatch(setIsRegistered("Y"));
    }
  }, [isRegistered, dispatch]);
  return (
    <>
      <FormLabel>
        <BackButton onClick={() => setActive(active - 1)}>
          <i className="fas fa-long-arrow-alt-left"></i>
        </BackButton>
        <Text>Enter car registration year ?</Text>
      </FormLabel>

      {/* Registration Place */}
      <Question>
        Registration <span>Place</span>
      </Question>
      <RegistrationWrapper>
        <InputWrapper>
          <AutoCompleteSelect
            size="medium"
            label="Registration Place"
            options={rtoList}
            loading={isLoading}
            _key={"label"}
            error={errors?.rto_name}
            selectedValue={rto_id && { id: rto_id, label: rto_name }}
            handleChange={(value) => {
              dispatch(setRtoDetails(value));
              setErrors((prev) => ({ ...prev, rto_name: "" }));
            }}
            getOptionLabel={(option) => option.label}
            getOptionSelected={(option, value) => option.label === value.label}
          />
        </InputWrapper>
      </RegistrationWrapper>


      <RegistrationWrapper>
        {/* Radio Button */}
        <div className="mr-200">
          <span className="fs-18 fw-600">Is your vehicle already registered?</span>
          <div className="mr-110">
            <RadioButton
              items={[
                { label: "Yes", value: "Y" },
                { label: "No", value: "N" },
              ]}
              defaultValue="Y"
              onChange={(value) => {
                dispatch(setIsRegistered(value));
                setErrors((prev) => ({ ...prev, isRegistered: "" }));
              }}
            />
          </div>
        </div>

        {/* Conditionally show DatePicker or Year dropdown */}
        {isRegistered === "Y" ? (
          <>
            <Question>
              Registration <span>Date</span>
            </Question>
            <InputWrapper>
              <DatePicker
                label="Registration Date"
                size="medium"
                value={registration_date}
                error={errors?.registration_date}
                disableFuture
                handleChange={(value) => {
                  dispatch(setRegistrationDate(value));
                  setErrors((prev) => ({ ...prev, registration_date: "" }));
                }}
              />
            </InputWrapper>
          </>

        ) : (
          <>
            <Question>
              Registration <span>Year</span>
            </Question>
            <InputWrapper>
              <AutoCompleteSelect
                size="medium"
                label="Registration Year"
                error={errors?.registration_year}
                selectedValue={registration_year}
                handleChange={(value) => {
                  dispatch(setRegistrationYear(value));
                  setErrors((prev) => ({ ...prev, registration_year: "" }));
                }}
                options={getLastNYears(15)}
              />
            </InputWrapper>
          </>
        )}
        <Question>
          Purchase <span>Date</span>
        </Question>
        <InputWrapper>
          <DatePicker
            label="Purchase Date"
            size="medium"
            value={purchase_date}
            error={errors?.purchase_date}
            disableFuture
            handleChange={(value) => {
              dispatch(setPurchaseDate(value));
              setErrors((prev) => ({ ...prev, purchase_date: "" }));
            }}
          />
        </InputWrapper>
      </RegistrationWrapper>

      {/* Save button */}
      <RegistrationWrapper>
        <Button
          primary
          className="w-60 ml-150 mt-24"
          onClick={() => {
            let newErrors = {};
            let isValid = true;

            if (!rto_id) {
              newErrors.rto_name = "Registration place is required";
              isValid = false;
            }
            if (!purchase_date) {
              newErrors.purchase_date = "Purchase date is required";
              isValid = false;
            }
            if (!isRegistered) {
              newErrors.isRegistered = "Please select if car is registered";
              isValid = false;
            }
            if (isRegistered === "Y") {
              if (!registration_date) {
                newErrors.registration_date = "Registration date is required";
                isValid = false;
              }
              newErrors.registration_year = "";
            } else if (isRegistered === "N") {
              if (!registration_year) {
                newErrors.registration_year = "Registration year is required";
                isValid = false;
              }
              newErrors.registration_date = "";
            }

            setErrors(newErrors);

            if (isValid) {
              onSave();
            }
          }}
          css={`
    width: 60%;
    margin: 24px auto 0;
    @media (max-width: 576px) {
      width: 100%;
      
    }
  `}
        >
          Save and Continue
        </Button>
      </RegistrationWrapper>
    </>
  );
};

export default Registration;
